module.exports = __webpack_public_path__ + "img/viva_peru.7d92b4a9.png";